import React from 'react';
export function ValueStack() {
  const items = [{
    name: '📗 Tomo I — La Base del Control',
    value: '$19,999'
  }, {
    name: '📘 Tomo II — La Mente del Campeón',
    value: 'incluido'
  }, {
    name: '🎧 Bono #1 — Meditaciones del Guerrero',
    value: '$9,500'
  }, {
    name: '📋 Bono #2 — Plan de 30 Días',
    value: '$7,000'
  }, {
    name: '⚡ Bono #3 — Guía de Emergencia',
    value: '$5,000'
  }, {
    name: '🗺️ Bono #4 — Mapa del Placer Sagrado',
    value: '$9,500'
  }, {
    name: '🤲 Bono #5 — Maestría Oral y Manual',
    value: '$7,500'
  }, {
    name: '💬 Bono #6 — Scripts de Conexión',
    value: '$5,000'
  }];
  return <section className="bg-gradient-to-b from-[#0a0a0a] via-[#100800] to-[#0a0a0a] py-[36px] px-5 text-center" data-id="element-176">
      <div className="max-w-[860px] mx-auto px-5" data-id="element-177">
        <h2 className="font-montserrat font-black text-[clamp(1.5rem,4vw,2.4rem)] text-brand-white uppercase mb-2 leading-[1.15]" data-id="element-178">
          El Valor Real de
          <br data-id="element-179" />
          <span className="text-brand-red" data-id="element-180">Todo lo que Recibes</span>
        </h2>
        <div className="w-[60px] h-[3px] bg-brand-red mx-auto mt-[10px] mb-[22px] rounded-[2px]" data-id="element-181"></div>

        <table className="w-full border-collapse my-[16px] text-left" data-id="element-182">
          <tbody data-id="element-183">
            {items.map((item, idx) => <tr key={idx} className="border-b border-[#1a1a1a] transition-colors duration-200 hover:bg-[#111]" data-id="element-184">
                <td className="py-[14px] px-2 text-[0.95rem] text-brand-gray-text" data-id="element-185">
                  {item.name}
                </td>
                <td className="py-[14px] px-2 text-[0.95rem] text-right font-montserrat font-bold text-brand-gold whitespace-nowrap" data-id="element-186">
                  {item.value}
                </td>
              </tr>)}
            <tr className="bg-gradient-to-br from-[#150000] to-[#100000]" data-id="element-187">
              <td className="py-[18px] px-2 text-[1.1rem] font-montserrat font-black text-brand-white uppercase tracking-[1px]" data-id="element-188">
                💰 Valor Total del Sistema Completo
              </td>
              <td className="py-[18px] px-2 text-[1.4rem] text-right font-montserrat font-bold text-brand-red whitespace-nowrap" data-id="element-189">
                $63,499
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>;
}